module.exports = __webpack_public_path__ + "img/join-1-en.fe105c53.png";